import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

const getLocalDate = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const PrivateRoute = ({ children }) => {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const lastLoginDate = localStorage.getItem("lastLoginDate");
  const currentDate = getLocalDate();

  console.log("Checking route:", location.pathname);

  if (lastLoginDate && lastLoginDate !== currentDate) {
    console.log("❌ Auto Logout: Date has changed!");
    localStorage.removeItem("token"); // Remove session token
    localStorage.removeItem("user");
    localStorage.setItem("lastLoginDate", currentDate); // Update login date
    return <Navigate to="/" replace />;
  }

  return token ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
